type PriceInput = number | string | null | undefined;

export function toPositivePrice(value: PriceInput): number | null {
  if (value == null) return null;

  const normalized =
    typeof value === 'string'
      ? Number(value.trim().replace(/,/g, ''))
      : Number(value);

  if (!Number.isFinite(normalized) || normalized <= 0) {
    return null;
  }

  return normalized;
}

export function firstPositivePrice(...values: PriceInput[]): number {
  for (const value of values) {
    const price = toPositivePrice(value);
    if (price != null) return price;
  }

  return 0;
}

